// @ts-nocheck
import { useTranslation } from 'next-i18next';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import SwiperCore, { EffectFade, Navigation, Pagination } from 'swiper/core';
import { useRef, useState } from 'react';
import Image from 'next/image';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Icon from '../common/Icon';

SwiperCore.use([EffectFade, Navigation, Pagination]);

const SetupHead = () => {
  const { t, i18n } = useTranslation();
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const pagination = { clickable: true };
  const lng = i18n.language;
  const [isOpen, setIsOpen] = useState(false);
  const imgSrc = [
    `/img/steps/setup1_${lng}_full.png`,
    `/img/steps/setup2_${lng}_full.png`,
    `/img/steps/setup3_${lng}_full.png`,
    `/img/steps/setup4_${lng}_full.png`,
  ];
  const [imgIndex, setImgIndex] = useState(0);

  const handlerCreator = (index) => () => {
    setIsOpen(true);
    setImgIndex(index);
  };

  return (
    <div className="setup-head">
      <div className="big-title">
        <h1>{t('how-to-setup_welcome_header')}</h1>
      </div>

      <div className="steps">
        {!!isOpen && (
          <Lightbox
            mainSrc={imgSrc[imgIndex]}
            onCloseRequest={() => setIsOpen(false)}
            enableZoom={false}
            imagePadding={30}
            wrapperClassName={'steps-full-image'}
          />
        )}
        <Swiper
          slidesPerView={4}
          effect="fade"
          pagination={pagination}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              allowTouchMove: false,
              effect: 'slide',
            },
          }}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
        >
          <SwiperSlide>
            <div className="num" />
            <div className="image zoom_image" onClick={handlerCreator(0)}>
              <Image
                style={{ borderRadius: '15px' }}
                src={`/img/steps/setup1_${lng}_full.png`}
                alt="Step 1"
                width={1082}
                height={677}
                unoptimized
              />
              <span className="zoom-pic">
                <Icon name="30-zoom" file="sprite" width="30" height="30" />
              </span>
            </div>
            <div className="text" dangerouslySetInnerHTML={{ __html: t('how-to-setup_step1') }} />
          </SwiperSlide>
          <SwiperSlide>
            <div className="num" />
            <div className="image zoom_image" onClick={handlerCreator(1)}>
              <Image
                style={{ borderRadius: '15px' }}
                src={`/img/steps/setup2_${lng}_full.png`}
                alt="Step 2"
                width={1082}
                height={677}
                unoptimized
              />
              <span className="zoom-pic">
                <Icon name="30-zoom" file="sprite" width="30" height="30" />
              </span>
            </div>
            <div className="text" dangerouslySetInnerHTML={{ __html: t('how-to-setup_step2') }} />
          </SwiperSlide>
          <SwiperSlide>
            <div className="num" />
            <div className="image zoom_image" onClick={handlerCreator(2)}>
              <Image
                style={{ borderRadius: '15px' }}
                src={`/img/steps/setup3_${lng}_full.png`}
                alt="Step 3"
                width={1082}
                height={677}
                unoptimized
              />
              <span className="zoom-pic">
                <Icon name="30-zoom" file="sprite" width="30" height="30" />
              </span>
            </div>
            <div className="text" dangerouslySetInnerHTML={{ __html: t('how-to-setup_step3') }} />
          </SwiperSlide>
          <SwiperSlide>
            <div className="num" />
            <div className="image zoom_image" onClick={handlerCreator(3)}>
              <Image
                style={{ borderRadius: '15px' }}
                src={`/img/steps/setup4_${lng}_full.png`}
                alt="Step 4"
                width={1080}
                height={677}
                unoptimized
              />
              <span className="zoom-pic">
                <Icon name="30-zoom" file="sprite" width="30" height="30" />
              </span>
            </div>
            <div className="text" dangerouslySetInnerHTML={{ __html: t('how-to-setup_step4') }} />
          </SwiperSlide>
          <div className="nav">
            <div className="prev" ref={navigationPrevRef}>
              <Icon name="20-darr" file="sprite" width="20" height="20" />
            </div>
            <div className="next" ref={navigationNextRef}>
              <Icon name="20-darr" file="sprite" width="20" height="20" />
            </div>
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default SetupHead;
